export const logo = require("./logo.png")
export const logoFoodAngel = require("./logo-food-angel.png")
export const iconLogo = require("./icon-logo.png")
export const micoin = require("./micoin.png")
export const linkLogo = require("./link-logo.jpeg")
export const wsLogo = require("./ws-logo.jpg")
